module.exports = __webpack_public_path__ + "ba.svg?726a63bdd3cf84a489ff0cca37cd4e34";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ba.svg
// module id = 1192
// module chunks = 27